import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addExpenseApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addExpense = createAsyncThunk('addExpense', async (payload) => {
  return await addExpenseApi(payload);
});

const addExpenseSlice = createSlice({
  name: 'addExpense', // Unique Name
  initialState,
  reducers: {
    addExpenseReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addExpense.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addExpense.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addExpense.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addExpenseReset } = addExpenseSlice.actions;

export default addExpenseSlice.reducer;
